/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralAiResponseDto } from '../../models/general-ai-response-dto';
import { RequestAiEnhancementDto } from '../../models/request-ai-enhancement-dto';

export interface DocumentAiControllerAiEnhancement$Params {
      body: RequestAiEnhancementDto
}

export function documentAiControllerAiEnhancement(http: HttpClient, rootUrl: string, params: DocumentAiControllerAiEnhancement$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerAiEnhancement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralAiResponseDto>;
    })
  );
}

documentAiControllerAiEnhancement.PATH = '/api/document-ai/ai-enhancement';
